// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  environmentString: 'Development',
  apiUrl: 'https://crossover.dvlp.ntsapps.nl/api/',
  cognito: {
    userPoolId: 'eu-central-1_M4u6EbRNt',
    userPoolClientId: '5or22p06t5ih0v964g2ahseirh'
  },
  clientId: '5or22p06t5ih0v964g2ahseirh',
  responseType: 'code',
  scope: 'openid+profile',
  redirectUri: 'https://crossover.dvlp.ntsapps.nl/api/auth',
  logoutUri: 'https://crossover.dvlp.ntsapps.nl/api/logout',
  loginUrl: '',
  logoutUrl: ''
};

environment.loginUrl = `https://auth.crossover.dvlp.ntsapps.nl/login/continue?client_id=${environment.clientId}&response_type=${environment.responseType}&scope=${environment.scope}&redirect_uri=${environment.redirectUri}`;
environment.logoutUrl = `https://auth.crossover.dvlp.ntsapps.nl/logout?client_id=${environment.clientId}&response_type=${environment.responseType}&scope=${environment.scope}&redirect_uri=${environment.logoutUri}`;
